import {
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  DialogActions,
  Button,
} from '@mui/material';
import React from 'react';
import {useSnackbar} from 'notistack';
import {useAddPaymentMethodMutation, useGetPaymentMethodsQuery} from 'api';
import PaymentMethodForm from './PaymentMethodForm';

function CreatePaymentMethodModal({open, onClose}) {
  const {isLoading, isError} = useGetPaymentMethodsQuery();
  const formRef = React.useRef();
  const [addPaymentMethod] = useAddPaymentMethodMutation();
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const {enqueueSnackbar} = useSnackbar();
  return (
    <Dialog fullWidth scroll="body" maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle mb={2} variant="h6">
        Create Payment Method
      </DialogTitle>
      <DialogContent>
        <PaymentMethodForm
          disabled={isLoading || isError}
          ref={formRef}
          onSubmit={async (values, actions) => {
            try {
              setIsSubmitting(true);
              const newObj = {
                ...values,
              };
              await addPaymentMethod(newObj).unwrap();
              actions.resetForm();
              enqueueSnackbar('PaymentMethod created successfully', {
                variant: 'success',
              });
              onClose();
            } catch (e) {
              const message =
                e.status === 400 ? e.PaymentMethodResponse?.details?.[0]?.message : undefined;
              enqueueSnackbar(message || 'Failed to create PaymentMethod', {
                variant: 'error',
              });
            } finally {
              setIsSubmitting(false);
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={isSubmitting} color="inherit" variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button
          endIcon={isSubmitting ? <CircularProgress ml={2} size={16} /> : null}
          disabled={isSubmitting}
          color="primary"
          variant="contained"
          onClick={() => formRef.current?.submit?.()}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CreatePaymentMethodModal;
